﻿var vm;

(function () {
    'use strict';
    var controllerId = 'appointmentReportCtrl';
    angular
        .module('app.controllers')
        .controller(controllerId, appointmentReportCtrl)

    appointmentReportCtrl.$inject = ['common', 'datacontext', '$http', '$scope', '$stateParams'];

    function appointmentReportCtrl(common, datacontext, $http, $scope, $stateParams) {
        vm = this;
        vm.idap;
        vm.printAppointment = printAppointment;

        init();
        getAppointmentById($stateParams.idap);

        function init() {
            common.activateController([])
                .then(function (data) { });
        }

        function printAppointment() {
            var printContents = $('#container').html();
            var popupWin = window.open('', '_blank', 'width=300,height=300');
            popupWin.document.open();
            popupWin.document.write(printContents);

            $(document).ready(function () {
                popupWin.print();
                popupWin.document.close();
            });
        }

        function getAppointmentById(appointmentId) {
            return datacontext.appointment.getAppointmentById(appointmentId).then(function (data) {


                data = data;

                if (data) {
                    //campos texto
                    vm.citaid = appointmentId;
                    vm.cita = data.Appointment.AppointmentNo;
                    vm.equipo = data.Appointment.EquipmentNo;
                    vm.fechahora = formatDisplayDate(data.Appointment.AppointmentDate);
                    vm.patio = data.Appointment.YardName;
                    vm.latitud = "latitud"; //data.Appointment.latitude;
                    vm.longitud = "longitud"; //data.Appointment.longitude;
                    vm.estado = data.Appointment.AppointmentStatusName;
                    vm.cliente = data.Appointment.CustomerName;
                    vm.contactocliente = "contactocliente"; //data.Appointment.customerContact;
                    vm.documentocliente = "documentocliente"; //data.Appointment.customerDocumentNo;
                    vm.direccioncliente = "direccioncliente";  //data.Appointment.customerAddress;
                    vm.conductor = data.Appointment.DriverName;
                    vm.empresatransporte = data.Appointment.TruckerName;
                    vm.conductordocumento = data.Appointment.DriverDocument;
                    vm.empresatransportedocumento = data.Appointment.TruckerDocument;
                    vm.placa = data.Appointment.LicensePlateNo;
                    vm.nroreferencia = data.Appointment.ReferenceDocumentNo;
                    vm.naviera = data.Appointment.CarrierName;
                    vm.isocode = data.Appointment.iSOCode;
                    vm.equipos = data.Appointment.AppointmentEquipments;
                }

            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        function formatDisplayDate(val) {
            var d = new Date(val);
            var realHours = d.getHours();

            var datePart = d.toLocaleDateString();
            if (datePart.split("/").length == 3) {
                datePart = formatDatePortion(datePart.split("/")[0]) + "/" + formatDatePortion(datePart.split("/")[1]) + "/" + datePart.split("/")[2];
            }

            return datePart + " " + formatDatePortion(realHours) + ":" + formatDatePortion(d.getMinutes()) + ":" + formatDatePortion(d.getSeconds());
        }

        function formatDatePortion(val) {
            var n_val = ("0" + val);
            if (n_val.length <= 2)
                return n_val
            else
                return n_val.substr(1, 2);
        }
    }
})();